import apiClientService from "./ApiClientService";

// „Lecții suplimentare” (administratori, manageri): GET /extra-lessons → { now, courseLessons, students: [...] }

export async function fetchExtraLessons() {
   const res = await apiClientService.get("/extra-lessons");
   if (res.ok) return res.json();
   let msg = "Nu am putut încărca lista.";
   try {
      const err = await res.json();
      if (err?.message) msg = Array.isArray(err.message) ? err.message.join(" ") : err.message;
   } catch {}
   const error = new Error(msg);
   error.status = res.status;
   throw error;
}
